import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import {getUserToken} from "../utils/helper";
import {stringify} from "qs";
import {settings} from "@/Settings";
import {router} from "@/router";

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);

        Vue.axios.defaults.baseURL = settings.API_SERVER;
    },
    setHeader() {
        Vue.axios.defaults.headers.common[
            "Authorization"
            ] = `Bearer ${getUserToken()}`;

        Vue.axios.interceptors.response.use(
            function (response) {
                return response;
            },
            function (error) {
                console.error(error);
                if (error.response && (401 === error.response.status || 403 === error.response.status)) {
                    // this.$toast.error("Your session has ended!");
                    router.push("/login");
                } else {
                    return Promise.reject(error);
                }
            }
        );
    },
    query(resource, params) {
        return Vue.axios
            .get(resource, {
                params: params,
                paramsSerializer: (params) => {
                    return stringify(params, {arrayFormat: "repeat"});
                },
            })
            .catch((error) => {
                throw new Error(`[RWV] ApiService ${error}`);
            });
    },

    get(resource) {
        return Vue.axios.get(`${resource}`).catch((error) => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },

    post(resource, params) {
        return Vue.axios.post(`${resource}`, params);
    },

    postFormData(resource, params) {
        return Vue.axios.post(`${resource}`, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    },

    update(resource, slug, params) {
        return Vue.axios.put(`${resource}/${slug}`, params);
    },

    put(resource, params) {
        return Vue.axios.put(`${resource}`, params);
    },

    delete(resource, slug, params) {
        return Vue.axios.delete(`${resource}/${slug}`, params).catch((error) => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },

    patch(resource, params) {
        return Vue.axios.patch(`${resource}`, params);
    },

    patchBySlug(resource, slug, params) {
        return Vue.axios.patch(`${resource}/${slug}`, params);
    },
};

export default ApiService;

export const UserService = {
    login(params) {
        return ApiService.post("/user/login", params);
    },
};
export const LookupService = {
    getGraduateTypes() {
        return ApiService.get("/graduateTypes");
    },
    getTrainingCenters() {
        return ApiService.query("/trainingCenter");
    },
    getHealthProffesionsWP(page, itemsPerPage, name) {
        return ApiService.get(
            `/healthProfessions?page=${page}&pageSize=${itemsPerPage}&name=${name}`);
    },
    getHealthProffesions() {
        return ApiService.get("/healthProfessions");
    },
    getCourses() {
        return ApiService.get("/courses/drp");
    },
    getProgramTypes() {
        return ApiService.get("/programTypes");
    },
    getCourseLevel() {
        return ApiService.get("/courseLevels");
    },
    getTrainerTypes() {
        return ApiService.get("/trainerTypes");
    },
    getPrograms() {
        return ApiService.get("/programs");
    },
    getProgramsDrp(id) {
        const url = id ? `/programs/drps?categoryId=${id}` : `/programs/drps`;
        return ApiService.get(url);
    },
    getTrainers() {
        return ApiService.get("/Trainers");
    },
    getTrainees() {
        return ApiService.get("/trainees");
    },
    getProfession() {
        return ApiService.get("/professions");
    },
    getEducationalLevel() {
        return ApiService.get("/educationalLevels");
    },
    getCategories() {
        return ApiService.get("/category");
    },
    getRegion() {
        // return ApiService.get("/location");
        return ApiService.get("/mfr/regions/drp");
    },
    getTrainerSelectionCriteriaWP(page, itemsPerPage, name) {
        return ApiService.get(
            `/trainerSelectionCriteria?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
    },
    getTrainerSelectionCriteria() {
        return ApiService.get("/trainerSelectionCriteria");
    },
    getWorkExperience() {
        return ApiService.get("/workExperience");
    },
    getTrainingCategories() {
        return ApiService.get("/trainingCategory");
    },
    getLevelOfStudies() {
        return ApiService.get("/levelOfStudies");
    },
    getLevelOfStudiesWP(page, itemsPerPage, name) {
        return ApiService.get(
            `/levelOfStudies?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
    },
    getAccreditedBy() {
        return ApiService.get("/accreditedBy");
    },
    getCourseOwners() {
        return ApiService.get("/courseOwners");
    },
    getAudiences() {
        return ApiService.get("/targetAudiences");
    },
    getTrainingCourseUsed() {
        return ApiService.get("/trainingCourseUsed");
    },
    getFoundedBy() {
        return ApiService.get("/fundedBy");
    },
    getActivityDeliveries() {
        return ApiService.get("/activityDeliveries");
    },
    getCpdProviders() {
        return ApiService.get("/trainingCenters");
    },
    getZones() {
        return ApiService.get("/zones");
    },
    getZoneByRegionId(regionId) {
        let url = regionId ? `/mfr/zones/drp?regionId=${regionId}` : "/mfr/zones/drp";
        return ApiService.get(url);
    },
    getWoredaByZoneId(zoneId) {
        let url = zoneId ? `/mfr/woredas/drp?zoneId=${zoneId}` : "/mfr/woredas/drp";
        return ApiService.get(url);
    },
    getFacilityByWoredaId(woredaId) {
        let url = woredaId ? `/mfr/facilities/drp?woredaId=${woredaId}` : "/mfr/facilities/drp";
        return ApiService.get(url);
    },
    getWoredas() {
        return ApiService.get("/woredas");
    },
    getExpertLevels() {
        return ApiService.get("/expertLevels");
    },
    getFacilityTypes() {
        return ApiService.get("/facilityTypes");
    },
    getUserFacilities(locationId, facilityTypeId) {
        return ApiService.get(
            "/facilities/" + `${locationId}` + "/" + `${facilityTypeId}`
        );
    },
    getAllUserFacilitiesWP(page, itemsPerPage, name) {
        return ApiService.get(
            `/facilities?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
    },
    getAllUserFacilities() {
        return ApiService.get("/facilities");
    },
    getAccredatorOwnership() {
        return ApiService.get("/accredatorOwnership");
    },
    getNewTraineeFacilities() {
        return ApiService.get("/newTraineeFacilities");
    },
    getTraineeFacilities() {
        return ApiService.get("/traineeFacilities");
    },
    traineeFacilitiesLookup(page, itemsPerPage, name) {
        return ApiService.get(
            `/traineeFacilities/traineeFacilitiesLookup?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
    },
    getUniversityOwnership() {
        return ApiService.get("/universityOwnership");
    },
    getGenerationLevels() {
        return ApiService.get("/generationLevel");
    },
    getUniversities() {
        return ApiService.get("/universities");
    },
    getUniversitiesWP(page, itemsPerPage, name) {
        return ApiService.get(
            `/universities?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
    },
    getCertReasons() {
        return ApiService.get("/certificateReasons");
    },
    getCertReasonsWP(page, itemsPerPage, name) {
        return ApiService.get(
            `/certificateReasons?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
    },
    getStudentStatuses() {
        return ApiService.get("/studentStatuses");
    },
    getEducationalPrograms() {
        return ApiService.get("/educationalPrograms");
    },
    getEducationalProgramsWP(page, itemsPerPage, name) {
        return ApiService.get(
            `/educationalPrograms?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
    },
    getDisciplines() {
        return ApiService.get("/disciplines");
    },
    getDisciplinesWP(page, itemsPerPage, name) {
        return ApiService.get(
            `/disciplines?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
    },
};
